const MONTHS = [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro'
]

// Formats an ISO date (YYYY-MM-DD or a full timestamp) the same way on the server and in the browser.
export const formatDate = (value: string): string => {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? '')

    if (!match) return value ?? ''

    const [, year, month, day] = match
    const monthName = MONTHS[Number(month) - 1]

    if (!monthName) return value

    return `${Number(day)} de ${monthName} de ${year}`
}

// Formats a number the Brazilian way (dot thousands separator, comma decimals), without depending on the runtime locale.
export const formatNumber = (value: number, decimals = 0): string => {
    const [integer, fraction] = value.toFixed(decimals).split('.')
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

    return fraction ? `${grouped},${fraction}` : grouped
}
